<template>
  <div class="bar-menu-separator"></div>
</template>